function l(l){var i,n;return{title:null!==(i=null==l?void 0:l.title)&&void 0!==i?i:null,description:null!==(n=null==l?void 0:l.description)&&void 0!==n?n:null}}export{l as shopifySeoToUnlikelyPageSeo};
//# sourceMappingURL=seo.js.map
